import { SavedFilterInterface } from '../../../interfaces/saved-filter.interface';

export class SaveFilterAction {
    public static readonly type = '[JobsPlacements] Save filter';

    constructor(public filter: SavedFilterInterface) { }
}
